<!-- Banner "Sorteo especial rumbo a tu primer auto".
     A diferencia de las landings de egresados 2026, aqui el texto no viene
     en un PNG: la carpeta sorteo-prepa solo trae car.png y logo.png, asi
     que el titulo se arma con tipografia del sitio (sofiapro black +
     Amanda Signature para el "rumbo a tu"). Asi escala solo en celular y
     no se pixelea. Todo el layout es bootstrap 4 (row / col-12 col-md-6). -->
<section class="hero-sorteo-especial">
    <div class="container-fluid px-0">
        <div class="row no-gutters align-items-end">

            <!-- Auto (car.png ya trae la carretera dibujada): siempre
                 pegado al borde izquierdo del banner. En celular no se
                 muestra (d-none) porque a ese ancho el recorte del auto no
                 se entiende; queda solo el logo y el titulo. -->
            <div class="col-12 col-md-6 hse-col-auto order-1 d-none d-md-block">
                <img src="/assets/images/sorteo2026/sorteo-prepa/car.png" class="hse-auto"
                    alt="Kia K3, premio del Sorteo Especial Rumbo a tu Primer Auto">
            </div>

            <!-- Logo + titulo. El wrapper .hse-texto-wrap centra el bloque
                 dentro de su mitad: sin el, el titulo se estiraba hasta el
                 borde derecho del banner y se veia descuadrado. -->
            <div class="col-12 col-md-6 hse-col-texto order-2 text-center" data-aos="zoom-in">
                <div class="hse-texto-wrap">
                    <img src="/assets/images/sorteo2026/sorteo-prepa/logo.png" class="hse-logo"
                        alt="Sorteos Anáhuac">

                    <h1 class="hse-titulo">
                        <span class="hse-linea1">SORTEO ESPECIAL</span>
                        <span class="hse-linea2"><span class="hse-linea2-txt">rumbo a tu</span></span>
                        <span class="hse-linea3">PRIMER AUTO</span>
                    </h1>
                </div>
            </div>

        </div>
    </div>
</section>

<br><br>
<section class="stc-winners-opt so2">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 class="titulo-oficial">
                    LISTA DE PARTICIPANTES SORTEO
                    <span class="d-block">
                        RUMBO A TU PRIMER AUTO 2026
                    </span>
                </h2>
            </div>

            <!-- Lista que se arma con el Excel. Mismo bloque que usan las
                 demas listas de participantes (participantes-egresados-2026,
                 participantessorteopt, -lealtad, -amigo, -son): buscador
                 arriba, tabla .table-striped .table-hover con los colores
                 que pone .stc-winners-opt en el sass global, y al final los
                 pagination-controls. El overflow-x deja que la tabla se
                 desplace sola en pantallas chicas en vez de romper el ancho
                 del container. -->
            <div class="col-md-12">
                <div class="text-center" style="overflow-x: auto;">
                    <label for="search" class="mt-5"
                        style="text-align: left !important; width: 100%; font-weight: 600; font-size: 18px;">Buscar:</label>
                    <input id="search" type="text" class="form-control mb-3" placeholder="Ingresa nombre o folio"
                        [(ngModel)]="searchText" (input)="filterData()" />

                    <table class="table table-striped table-hover mt-3">
                        <thead>
                            <tr class="cols">
                                <th scope="col" style="width: 30%;"><span>FOLIO</span></th>
                                <th scope="col" style="width: 70%;"><span>NOMBRE</span></th>
                            </tr>
                        </thead>
                        <tbody class="text-center">
                            <tr
                                *ngFor="let participante of filteredData | paginate: { itemsPerPage: 50, currentPage: p }">
                                <td class="text-center align-middle" style="width: 30%;">
                                    <strong>{{ participante.folio }}</strong>
                                </td>

                                <!-- El nombre va en mayusculas por CSS, no por codigo,
                                     igual que en las demas listas. Si SEGOB pide
                                     abreviar los apellidos, el componente ya trae
                                     getInitials() listo para envolver este valor. -->
                                <td class="text-center align-middle text-uppercase" style="width: 70%;">
                                    {{ getFirstName(participante.nombre) }}
                                </td>
                            </tr>

                            <tr *ngIf="filteredData.length === 0">
                                <td colspan="2" class="text-center text-muted py-4 align-middle">
                                    No se encontraron datos.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <pagination-controls (pageChange)="p = $event" previousLabel="Anterior"
                        nextLabel="Siguiente"></pagination-controls>
                </div>
            </div>


            <!-- Legales del sorteo especial (los dio el area, tal cual).
                 El calendario de entrega y el permiso SEGOB son propios de
                 este sorteo, no los de egresados 2026. -->
            <div class="col-12 mt-5 pt-0 footer-egr">
                <p class="font-bold">
                    SORTEO ESPECIAL RUMBO A TU PRIMER AUTO
                </p>
                <p class="font-bold">
                    ENTREGA DE PREMIOS:
                </p>
                <p>Los premios mayores a 1,500 (UMA) $175,965.00 (Ciento setenta y cinco mil novecientos sesenta y cinco pesos 00/100 m.n.) se solicitará la presencia de un inspector de la DGJS para la entrega de estos, conforme al siguiente calendario de fechas: 25 de septiembre de 2026 a las 11:00 horas, entrega del Premio 1 del SORTEO ESPECIAL RUMBO A TU PRIMER AUTO. En las instalaciones de la Universidad Anáhuac México Campus Norte con domicilio en Av. Universidad Anáhuac no. 46 Huixquilucan, Estado de México. C.P. 52786.</p>

                <p>La persona que resulte ganadora deberá presentar una identificación oficial vigente con fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses), Constancia de situación fiscal (mes en curso) y CURP; y el folio que le fue entregado vía correo electrónico y su identificación oficial.</p>

                <p>En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez, Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.</p>

                <p>Para más información sobre dónde reclamar la entrega de los premios, documentos necesarios para recibirlos diríjase a: www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México o al teléfono: 01(55) 5328-8096 ext 2137.</p>

                <p> <strong>PERMISO SEGOB:</strong> 20260230PS07</p>
            </div>

        </div>
    </div>
</section>
